<template>
    <el-form label-width="165px" label-position="right" ref="cooperationRuleForm" :rules="rules"
        :model="cooperationForm">
        <el-form-item class="el-form-item-spic" label="合作意向：">
            <span class="num">供货</span>
        </el-form-item>
        <el-form-item label="服务能力： 数据更新模式：" prop="supplyServiceCapability">
            <el-radio-group v-model="cooperationForm.supplyServiceCapability">
                <el-radio :label="0">以编辑数据为准</el-radio>
                <el-radio :label="1">以每日更新的系统数据为准</el-radio>
            </el-radio-group>
        </el-form-item>

        <el-form-item v-for=" item in serviceMap" :key="item.prop" :prop="item.prop" :label="item.label">
            <el-input-number v-if="cooperationForm.supplyServiceCapability == '0' || item.prop == 'deliveryTime	'" v-model="cooperationForm[item.prop]" style="margin-right:10px" width="100px"
                :precision="item.precision" :max="item.max" :min="item.min" label="描述文字"
                :controls="false"></el-input-number>
            <span class="renderText" v-if="cooperationForm.supplyServiceCapability == '1'">{{ cooperationForm[item.referenceValue] }}</span>
            <span class="ft-12">
                <span class="num">{{ item.unit }}</span>
                <span class="tbn-text" v-if="item.hisReferenceValue && cooperationForm.supplyServiceCapability == '0'"
                    @click="applySystemReferenceValue(item.prop, cooperationForm[item.referenceValue])">应用系统参考值</span>
                <span class="tips ft-12">{{ item.tips }}</span>
                <span v-if="item.hisReferenceValue && cooperationForm.supplyServiceCapability == '0'">系统参考值：
                    <!-- <span v-if="cooperationForm[item.referenceValue]">{{ cooperationForm[item.referenceValue] }}</span> -->
                    <span class="no-number">暂无</span>
                </span>
            </span>
        </el-form-item>

        <el-form-item label="商品能力： 数据更新模式：" prop="supplyItemCapability">
            <el-radio-group v-model="cooperationForm.supplyItemCapability">
                <el-radio :label="0">以编辑数据为准</el-radio>
                <el-radio :label="1">以每日更新的系统数据为准</el-radio>
            </el-radio-group>
        </el-form-item>

        <el-form-item v-for=" item in goodsMap" :key="item.prop" :prop="item.prop" :label="item.label">
            <el-input-number v-if="cooperationForm.supplyItemCapability == '0'" v-model="cooperationForm[item.prop]" style="margin-right:10px" width="100px"
                :precision="item.precision" :max="item.max" :min="item.min" label="描述文字"
                :controls="false"></el-input-number>
            <span class="renderText" v-if="cooperationForm.supplyItemCapability == '1'">{{ cooperationForm[item.referenceValue] }}</span>
            <span class="ft-12">
                <span class="num">{{ item.unit }}</span>
                <span class="tbn-text" v-if="item.hisReferenceValue && cooperationForm.supplyItemCapability == '0'">应用系统参考值</span>
                <span class="tips ft-12">{{ item.tips }}</span>
                <span v-if="item.hisReferenceValue && cooperationForm.supplyItemCapability == '0'">系统参考值：
                    <!-- <span v-if="cooperationForm[item.referenceValue]">{{ cooperationForm[item.referenceValue] }}</span> -->
                    <span class="no-number">暂无</span>
                </span>
            </span>
        </el-form-item>
        <el-form-item class="el-form-item-spic"  label="合作模式：" prop="cooperationMode">
            <el-checkbox-group v-model="cooperationForm.cooperationMode">
                <el-checkbox :label="'1'" name="type">一件代发</el-checkbox>
                <el-checkbox :label="'2'" name="type">批量采购</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
    props: {
        editCooperationFrom: {
            type: Object,
            default: () => {
                return {
                    cooperationMode: [], // 合作模式 1: 一件代发、 2:批量采购 - 可多选，逗号分隔
                    deliveryTime: 1,
                    distributorCount: null,
                    distributeGoodCount: null,
                    monthlyGoodUpdate: null,
                    supplyServiceCapability: 0,
                    supplyItemCapability: 0,
                    deliveryTime: '',
                    deliverRate24H: '',
                    deliverRate48H: '',
                    afterSalesRate: '',
                    deliveryItemCount30D: '',
                    distributorCount: '',
                    distributeGoodCount: '',
                    monthlyGoodUpdate: '',
                    avgSupplyPrice: '',
                }
            }
        }
    },
    data () {
        return {
            serviceMap: [
                {
                    label: '发货时效:',
                    prop: 'deliveryTime',
                    precision: 0,
                    max: 99999,
                    min: 0,
                    unit: '小时',
                    tips: '完成订单发货的承诺时间',
                    hisReferenceValue: false,
                    referenceValue: '',
                }, {
                    label: '24h支付揽收率:',
                    prop: 'deliverRate24H',
                    precision: 2,
                    max: 100,
                    min: 0,
                    unit: '%',
                    tips: '基于付款时间在24h内发货的订单/24h总订单*100%。',
                    hisReferenceValue: true,
                    referenceValue: '',
                }, {
                    label: '48h发货率:',
                    prop: 'deliverRate48H',
                    precision: 2,
                    max: 100,
                    min: 0,
                    unit: '%',
                    tips: '基于付款时间在48h内发货的订单/48h总订单*100%。',
                    hisReferenceValue: true,
                    referenceValue: '',
                }, {
                    label: '售后率:',
                    prop: 'afterSalesRate',
                    precision: 2,
                    max: 100,
                    min: 0,
                    unit: '%',
                    tips: '基于付款时间统计近30天内售后工单关联的订单/30天总订单*100%。',
                    hisReferenceValue: true,
                    referenceValue: '',
                }, {
                    label: '月均发货数:',
                    prop: 'deliveryItemCount30D',
                    precision: 0,
                    max: 9999999,
                    min: 1,
                    unit: '',
                    tips: '基于付款时间，近90天订单关联的商品数量/3。',
                    hisReferenceValue: true,
                    referenceValue: '',
                }, {
                    label: '分销商数:',
                    prop: 'distributorCount',
                    precision: 0,
                    max: 99999,
                    min: 1,
                    unit: '',
                    tips: '截止昨天，建立了分销关系的分销商数。',
                    hisReferenceValue: true,
                    referenceValue: '',
                },
            ],
            goodsMap: [
                {
                    label: '可分销商品:',
                    prop: 'distributeGoodCount',
                    precision: 0,
                    max: 99999,
                    min: 1,
                    unit: '',
                    tips: '截止昨天，分销小店内的款维度商品数。',
                    hisReferenceValue: true,
                    referenceValue: '',
                }, {
                    label: '月上新商品:',
                    prop: 'monthlyGoodUpdate',
                    precision: 0,
                    max: 99999,
                    min: 1,
                    unit: '',
                    tips: '基于付款时间，近90天订单关联的商品数量/3。',
                    hisReferenceValue: true,
                    referenceValue: '',
                }, {
                    label: '平均供货价:',
                    prop: 'avgSupplyPrice',
                    precision: 2,
                    max: 99999,
                    min: 0,
                    unit: '元',
                    tips: '分销小店内，规格商品分销价总和/规格商品数。',
                    hisReferenceValue: true,
                    referenceValue: '',
                },
            ],
            cooperationForm: {
                cooperationMode: [],
                deliveryTime: '',
                distributorCount: null,
                distributeGoodCount: null,
                monthlyGoodUpdate: null,
                supplyServiceCapability: '0',
                supplyItemCapability: '0',
                deliveryTime: '',
                deliverRate24H: '',
                deliverRate48H: '',
                afterSalesRate: '',
                deliveryItemCount30D	: '',
                distributorCount: '',
                distributeGoodCount: '',
                monthlyGoodUpdate: '',
                avgSupplyPrice: '',
            },
            rules: {
                cooperationMode: [
                    { type: 'array', required: true, message: '请至少选择一个合作模式', trigger: 'change' }
                ]
            }
        }
    },
    watch: {
        editCooperationFrom: {
            handler (v) {
                this.$set(this, 'cooperationForm', {
                    supplyServiceCapability: 0,
                    supplyItemCapability: 0,
                    ...v
                })
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        applySystemReferenceValue (key, value) {
            this.$set(this.cooperationForm, key, 0);
        },
        method_getFormData () {
            return new Promise((resolve, reject) => {
                this.$refs.cooperationRuleForm.validate(valid => {
                    if (valid) {
                        let cooperationMode = this.cooperationForm.cooperationMode.join(',')
                        resolve({ ...this.cooperationForm, cooperationMode })
                    } else {
                        resolve(false)
                    }
                })
            })
        },
        method_reset () {
            this.$refs.cooperationRuleForm.resetFields()
        }
    }
}
</script>

<style lang="scss" scoped>
.num {
    width: 30px;
    display: inline-block;
    text-align: center;
    margin-right: 20px;
    font-weight: bold;
}

.title {
    margin-right: 20px;
}
.renderText{
    padding-left: 10px;
    line-height: 28px;
}
.tbn-text {
    cursor: pointer;
    margin-right: 20px;
    color: #396CF3;
}

.tips {
    color: #B8B8B8;
}

.no-number {
    color: red;
}

.inline-block {
    display: inline-block;
}
.el-form-item-spic{
   
    ::v-deep .el-form-item__label{
        width: 80px !important;
    }
    ::v-deep .el-form-item__content{
        margin-left: 74px !important;
    }
}
</style>